import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Phone, Mail, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="logo">
              <div className="logo-icon">
                <Heart size={20} fill="white" stroke="none" />
              </div>
              <div className="logo-text">RV <span>Clinic</span></div>
            </div>
            <p>Providing exceptional healthcare services with compassion and cutting-edge technology. Your health is our mission.</p>
          </div>

          <div>
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/doctors">Our Doctors</Link></li>
            </ul>
          </div>

          <div>
            <h4>Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Cardiology</Link></li>
              <li><Link to="/services">Orthopedics</Link></li>
              <li><Link to="/services">Neurology</Link></li>
              <li><Link to="/services">Pediatrics</Link></li>
            </ul>
          </div>

          <div>
            <h4>Contact Info</h4>
            <ul className="footer-links">
              <li>
                <a href="tel:+917048944596">
                  <Phone size={14} /> +91 70489 44596
                </a>
              </li>
              <li>
                <a href="mailto:contact@rvtechnologies.net.in">
                  <Mail size={14} /> contact@rvtechnologies.net.in
                </a>
              </li>
              <li>
                <a href="#">
                  <MapPin size={14} /> Tower T3, 7th Floor, 739, Sector Techzone-IV, Greater Noida (West), GautamBudh Nagar, UP 201306
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 RV Clinic. All Rights Reserved. Powered by RV Technologies.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
